export const MIME_TYPE_CANDIDATES = [
  "audio/webm;codecs=opus",
  "audio/webm",
  "audio/mp4",
] as const;

export function selectSupportedMimeType(
  isTypeSupported: (mimeType: string) => boolean,
): string | undefined {
  return MIME_TYPE_CANDIDATES.find((mimeType) => isTypeSupported(mimeType));
}

export function audioConstraintsForDevice(
  deviceId?: string,
): MediaTrackConstraints {
  return {
    ...(deviceId ? { deviceId: { exact: deviceId } } : {}),
    channelCount: 1,
    echoCancellation: false,
    noiseSuppression: false,
    autoGainControl: false,
  };
}

export function createSegmentRecorder(
  stream: MediaStream,
  mimeType: string | undefined,
  Recorder: typeof MediaRecorder = MediaRecorder,
): MediaRecorder {
  const baseOptions: MediaRecorderOptions = mimeType ? { mimeType } : {};

  try {
    return new Recorder(stream, {
      ...baseOptions,
      audioBitsPerSecond: 24_000,
    });
  } catch {
    return new Recorder(
      stream,
      Object.keys(baseOptions).length > 0 ? baseOptions : undefined,
    );
  }
}

export function isLikelySilent(speechMs: number): boolean {
  return speechMs < 1_500;
}
